<template>
  <div class="book-table">
    <el-table
      :data="tableData_" 
      :row-class-name="tableRowClassName"
      :row-style="rowClassName"
      style="width: 100%"
      @row-click="rowActive"
      >
      <!-- border -->

      <el-table-column
        type="index" 
        label="序号"
        align="center"
        width="80">
        <template slot-scope="scope">
            <span>{{(page.index-1)*page.size+scope.$index+1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bookName"
        label="册名"
        align="center" >
        <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="scope.row.bookName" placement="right">
                <span class="chapter-view" v-html="toStringStyle(scope.row.bookName)"></span>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="chaptername"
        align="center"
        label="篇名">
        <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="scope.row.chaptername" placement="right">
                <span class="chapter-view" v-html="toStringStyle(scope.row.chaptername)"></span>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="author"
        align="center"
        label="注译者" > 
        <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="scope.row.author" placement="right">
                <span class="chapter-view" v-html="toStringStyle(scope.row.author)"></span>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="dfrom"
        align="center"
        label="出处" >
        <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="scope.row.dfrom" placement="right">
                <span class="chapter-view"  v-html="toStringStyle(scope.row.dfrom)"></span>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="publishdate"
        align="center"
        label="发表日期"
        width="140">
      </el-table-column>
      <el-table-column
        prop="className"
        align="center"
        label="类别">
        <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="scope.row.className" placement="right">
                <span class="chapter-view"  v-html="toStringStyle(scope.row.className)"></span>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="comment1"
        align="center"
        label="备注"
        width="140">
        <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="`${scope.row.comment2} ${scope.row.comment3}${scope.row.comment4}`" placement="left">
                <span class="chapter-view">{{scope.row.comment2}} &nbsp; {{scope.row.comment3}} &nbsp; {{scope.row.comment4}}</span>
            </el-tooltip>
        </template>
      </el-table-column> 
    </el-table>
  </div>
</template>

<script> 
export default {
  name: "headerCom",
  props:{
    list:Array,
    page:Object,
    seachText:String
  },
  data() {
    return { 
    };
  },
  computed: {
      tableData_(){
          return this.list
      }
  }, 
  methods: {
      toStringStyle(text){ 
        var reg = new RegExp(this.seachText, 'g');//g 全局匹配
        if(!text) return text
        var newHtml = text.replace(reg, '<font class="bh" color="red">'+this.seachText+'</font>'); //这里就是标红
        return newHtml
      },
      rowActive(row){ 
          this.$emit("row-click",{
              data:row
          })
      },
      rowClassName(){
          return 'row-height'
      },
      tableRowClassName({rowIndex}) { 
        if((rowIndex & 1) == 0){ //偶数
            return 'warning-row';
        }else{//奇数
            return 'success-row'
            } 
      }
  },
  mounted() {
      
  }
};
</script>
<style>
    .el-table th {
        background-color: #a19183;
        color: #f0ebe1;
    } 
    .el-table td {
        padding: 5px 0; 
    } 
    .el-table tr{
        cursor: pointer;
    } 
    .el-table tbody tr:hover>td { 
    background-color:#d4cdc2!important
}
  .el-table .warning-row {
    background:#fff;
  }

  .el-table .success-row {
    background: #e7e1e1;
  }
  .el-table .row-height{
      height: 20px;
  }
</style>
<style lang="less" scoped>
    .book-table{
        border-radius: 6px;
        overflow: hidden;
    }

    .chapter-view{ 
      display: block;
      width: 100%;
      white-space: nowrap;  
      overflow: hidden;
      text-overflow:ellipsis;
    }
</style> 
